// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var React = require("react");
var Common = require("../utils/Common.res.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var MM_wrk_unify = require("../worker/MM_wrk_unify.res.js");
var MM_api_editor = require("../api/MM_api_editor.res.js");
var MM_cmp_macros = require("../api/MM_cmp_macros.res.js");
var MM_wrk_client = require("../worker/MM_wrk_client.res.js");
var MM_wrk_editor = require("../worker/MM_wrk_editor.res.js");
var PaginationCmp = require("../ui-utils/PaginationCmp.res.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Belt_SetString = require("rescript/lib/js/belt_SetString.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_react_common = require("../ui-utils/MM_react_common.res.js");
var MM_substitution = require("../mm-utils/MM_substitution.res.js");
var Expln_React_Menu = require("../../rescript-utils/main/react-mui-components/Expln_React_Menu.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var Expln_React_Modal = require("../../rescript-utils/main/react-components/Expln_React_Modal.res.js");
var MM_cmp_rename_tab = require("./MM_cmp_rename_tab.res.js");
var MM_editor_history = require("../worker/MM_editor_history.res.js");
var List = require("@mui/material/List").default;
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Expln_utils_common = require("../../rescript-utils/main/Expln_utils_common.res.js");
var MM_cmp_editor_hist = require("./MM_cmp_editor_hist.res.js");
var MM_cmp_search_asrt = require("./MM_cmp_search_asrt.res.js");
var MM_wrk_editor_json = require("../test/MM_wrk_editor_json.res.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.res.js");
var MM_wrk_syntax_tree = require("../worker/MM_wrk_syntax_tree.res.js");
var Static_XML_to_HTML = require("../utils/Static_XML_to_HTML.res.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("../../rescript-utils/main/Expln_utils_promise.res.js");
var JsxPPXReactSupportU = require("rescript/lib/js/jsxPPXReactSupportU.js");
var Local_storage_utils = require("../ui-utils/Local_storage_utils.res.js");
var MM_cmp_export_proof = require("./MM_cmp_export_proof.res.js");
var MM_cmp_substitution = require("./MM_cmp_substitution.res.js");
var XML_formatting_help = require("../utils/XML_formatting_help.res.js");
var Button = require("@mui/material/Button").default;
var MM_cmp_pe_frame_full = require("../explorer/MM_cmp_pe_frame_full.res.js");
var MM_cmp_multiline_text = require("./MM_cmp_multiline_text.res.js");
var Checkbox = require("@mui/material/Checkbox").default;
var ListItem = require("@mui/material/ListItem").default;
var MenuItem = require("@mui/material/MenuItem").default;
var MM_cmp_merge_two_stmts = require("./MM_cmp_merge_two_stmts.res.js");
var MM_cmp_save_or_discard = require("./MM_cmp_save_or_discard.res.js");
var MM_cmp_unify_bottom_up = require("./MM_cmp_unify_bottom_up.res.js");
var Add = require("@mui/icons-material/Add").default;
var Hub = require("@mui/icons-material/Hub").default;
var MM_cmp_import_from_json = require("./MM_cmp_import_from_json.res.js");
var Menu = require("@mui/icons-material/Menu").default;
var IconButton = require("@mui/material/IconButton").default;
var Logout = require("@mui/icons-material/Logout").default;
var Search = require("@mui/icons-material/Search").default;
var ListItemText = require("@mui/material/ListItemText").default;
var MM_bottom_up_prover_params = require("../mm-utils/MM_bottom_up_prover_params.res.js");
var MM_cmp_editor_view_options = require("./MM_cmp_editor_view_options.res.js");
var MM_cmp_export_state_to_url = require("./MM_cmp_export_state_to_url.res.js");
var MM_wrk_editor_substitution = require("../worker/MM_wrk_editor_substitution.res.js");
var Restore = require("@mui/icons-material/Restore").default;
var MM_cmp_export_state_to_json = require("./MM_cmp_export_state_to_json.res.js");
var Bookmark = require("@mui/icons-material/Bookmark").default;
var ListItemButton = require("@mui/material/ListItemButton").default;
var MergeType = require("@mui/icons-material/MergeType").default;
var PlayArrow = require("@mui/icons-material/PlayArrow").default;
var MM_cmp_editor_select_theorems = require("./MM_cmp_editor_select_theorems.res.js");
var ArrowUpward = require("@mui/icons-material/ArrowUpward").default;
var PriorityHigh = require("@mui/icons-material/PriorityHigh").default;
var ArrowDownward = require("@mui/icons-material/ArrowDownward").default;
var DeleteForever = require("@mui/icons-material/DeleteForever").default;
var BookmarkBorder = require("@mui/icons-material/BookmarkBorder").default;
var Expln_React_ContentWithStickyHeader = require("../../rescript-utils/main/react-components/Expln_React_ContentWithStickyHeader.res.js");
var TextRotationNone = require("@mui/icons-material/TextRotationNone").default;
var BookmarkAddOutlined = require("@mui/icons-material/BookmarkAddOutlined").default;
var BookmarkRemoveOutlined = require("@mui/icons-material/BookmarkRemoveOutlined").default;

var editorStateLocStorKey = "editor-state";

var editorHistLocStorKey = "editor-hist";

var lastUsedAsrtSearchTypLocStorKey = "search-asrt-typ";

function getEditorLocStorKey(editorId) {
  return editorStateLocStorKey + "-" + editorId.toString();
}

function getEditorHistLocStorKey(editorId) {
  return editorHistLocStorKey + "-" + editorId.toString();
}

function editorSaveStateToLocStor(state, editorId) {
  Local_storage_utils.locStorWriteString(getEditorLocStorKey(editorId), Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)));
}

function histSaveToLocStor(hist, editorId) {
  var histStr = MM_editor_history.editorHistToString(hist);
  var locStorKey = getEditorHistLocStorKey(editorId);
  var oldHistStr = Local_storage_utils.locStorReadString(locStorKey);
  var histChanged = oldHistStr !== undefined ? oldHistStr !== histStr : true;
  if (histChanged) {
    return Local_storage_utils.locStorWriteString(locStorKey, histStr);
  }
  
}

function histReadFromLocStor(editorId) {
  var histStr = Local_storage_utils.locStorReadString(getEditorHistLocStorKey(editorId));
  if (histStr === undefined) {
    return ;
  }
  var hist = MM_editor_history.editorHistFromString(histStr);
  if (hist.TAG === "Ok") {
    return Caml_option.some(hist._0);
  }
  
}

function rndIconButton(icon, onClick, active, ref, title, smallBtnsOpt) {
  var smallBtns = smallBtnsOpt !== undefined ? smallBtnsOpt : false;
  return React.createElement("span", {
              ref: ref,
              title: title
            }, React.createElement(IconButton, {
                  onClick: (function (param) {
                      onClick();
                    }),
                  color: "primary",
                  style: smallBtns ? ({
                        padding: "2px"
                      }) : undefined,
                  disabled: !active,
                  children: Caml_option.some(icon)
                }));
}

function saveLastUsedTyp(ctx, typInt) {
  var typStr = MM_context.ctxIntToSym(ctx, typInt);
  if (typStr !== undefined) {
    localStorage.setItem(lastUsedAsrtSearchTypLocStorKey, typStr);
    return ;
  }
  
}

function getLastUsedTyp(ctx) {
  var typStr = localStorage.getItem(lastUsedAsrtSearchTypLocStorKey);
  if (typStr !== null) {
    return MM_context.ctxSymToInt(ctx, typStr);
  }
  
}

function jsonStrOptToEditorStateLocStor(jsonStrOpt) {
  return Belt_Option.flatMap(jsonStrOpt, (function (jsonStr) {
                return Belt_Result.mapWithDefault(MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr), undefined, (function (state) {
                              return state;
                            }));
              }));
}

function loadEditorInitialStateFromLocStor(editorId, preCtxData, initialStateLocStor) {
  var hist = histReadFromLocStor(editorId);
  if (hist === undefined) {
    return MM_wrk_editor_json.createInitialEditorState(preCtxData, initialStateLocStor, 0);
  }
  var hist$1 = Caml_option.valFromOption(hist);
  var nextStmtId = Core__Option.getOr(Core__Option.map(MM_editor_history.editorHistGetMaxIntStmtId(hist$1), (function (i) {
              return i + 1 | 0;
            })), 0);
  var stateFromLocStor = MM_wrk_editor_json.createInitialEditorState(preCtxData, initialStateLocStor, nextStmtId);
  var stateFromHistory = MM_editor_history.restoreEditorStateFromSnapshot(stateFromLocStor, hist$1, -1);
  if (stateFromHistory.TAG !== "Ok") {
    return stateFromLocStor;
  }
  var stateFromHistory$1 = stateFromHistory._0;
  if (MM_editor_history.editorStatesHaveSameContent(stateFromLocStor, stateFromHistory$1)) {
    return stateFromHistory$1;
  } else {
    return stateFromLocStor;
  }
}

var previousEditingIsNotCompletedTitle = "Previous editing is not completed";

var previousEditingIsNotCompletedText = "You've attempted to edit something in the editor while the previous edit is not complete. Please complete the previous edit before starting a new one.";

var infoAboutGettingCompletedProof = "In order to show a completed proof do the following: 1) Make sure the step you want to show a completed proof for is marked with a green chekmark. If it is not, try to \"unify all\"; 2) Select the step you want to show a completed proof for; 3) Select \"Show completed proof\" menu item.";

var infoAboutInliningTheorems = "In order to inline theorems do the following: 1) Make sure all steps you want to inline the proof for are marked with a green check mark. If they are not, try to \"unify all\"; 2) Select \"Inline theorems\" menu item.";

function MM_cmp_editor(props) {
  var onTabTitleChange = props.onTabTitleChange;
  var openFrameExplorer = props.openFrameExplorer;
  var setShowTabs = props.setShowTabs;
  var showTabs = props.showTabs;
  var ctxSelectorIsExpanded = props.ctxSelectorIsExpanded;
  var toggleCtxSelector = props.toggleCtxSelector;
  var initialStateLocStor = props.initialStateLocStor;
  var updateTabTitle = props.updateTabTitle;
  var addAsrtByLabel = props.addAsrtByLabel;
  var reloadCtx = props.reloadCtx;
  var preCtxData = props.preCtxData;
  var editorId = props.editorId;
  var modalRef = props.modalRef;
  var match = React.useState(function () {
        return false;
      });
  var setMainMenuIsOpened = match[1];
  var mainMenuIsOpened = match[0];
  var mainMenuButtonRef = React.useRef(null);
  var match$1 = React.useState(function () {
        return false;
      });
  var setContIsHidden = match$1[1];
  var contIsHidden = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setShowBkmOnly = match$2[1];
  var showBkmOnly = match$2[0];
  var showBkmOnlyRef = React.useRef(showBkmOnly);
  showBkmOnlyRef.current = showBkmOnly;
  var onOpenSubstitutionDialogRef = React.useRef(function () {
        
      });
  var match$3 = Local_storage_utils.useStateFromLocalStorageBool("editor-showCheckbox", true);
  var setShowCheckbox = match$3[1];
  var showCheckbox = match$3[0];
  var match$4 = Local_storage_utils.useStateFromLocalStorageBool("editor-showLabel", true);
  var setShowLabel = match$4[1];
  var showLabel = match$4[0];
  var match$5 = Local_storage_utils.useStateFromLocalStorageBool("editor-showType", true);
  var setShowType = match$5[1];
  var showType = match$5[0];
  var match$6 = Local_storage_utils.useStateFromLocalStorageBool("editor-showJstf", true);
  var setShowJstf = match$6[1];
  var showJstf = match$6[0];
  var match$7 = Local_storage_utils.useStateFromLocalStorageBool("editor-inlineMode", false);
  var setInlineMode = match$7[1];
  var inlineMode = match$7[0];
  var match$8 = Local_storage_utils.useStateFromLocalStorageBool("editor-smallBtns", false);
  var setSmallBtns = match$8[1];
  var smallBtns = match$8[0];
  var match$9 = Local_storage_utils.useStateFromLocalStorageInt("editor-steps-per-page", 100);
  var setStepsPerPage = match$9[1];
  var match$10 = Local_storage_utils.useStateFromLocalStorageBool("paren-autocomplete", true);
  var setParenAc = match$10[1];
  var parenAc = match$10[0];
  var match$11 = React.useState(function () {
        return loadEditorInitialStateFromLocStor(editorId, preCtxData, initialStateLocStor);
      });
  var setStatePriv = match$11[1];
  var state = match$11[0];
  var match$12 = React.useState(function () {
        var hist = histReadFromLocStor(editorId);
        if (hist !== undefined) {
          return MM_editor_history.editorHistAddSnapshot(Caml_option.valFromOption(hist), state);
        } else {
          return MM_editor_history.editorHistMake(state, preCtxData.settingsV.val.editorHistMaxLength);
        }
      });
  var setHistPriv = match$12[1];
  var hist = match$12[0];
  var stmtsToShow = showBkmOnly ? state.stmts.filter(function (stmt) {
          if (stmt.typ === "E" || stmt.isGoal || stmt.isBkm || MM_wrk_editor.userStmtHasAnyErrors(stmt) || stmt.labelEditMode || stmt.typEditMode || stmt.contEditMode) {
            return true;
          } else {
            return stmt.jstfEditMode;
          }
        }) : state.stmts;
  var stepsPerPage = Math.max(1, Math.min(match$9[0], 300));
  var numOfPages = Math.ceil(stmtsToShow.length / stepsPerPage) | 0;
  var maxPageIdx = numOfPages - 1 | 0;
  var match$13 = React.useState(function () {
        return 0;
      });
  var setPageIdx = match$13[1];
  var pageIdx = Math.max(0, Math.min(match$13[0], maxPageIdx));
  var stmtBeginIdx = Math.imul(pageIdx, stepsPerPage);
  var stmtEndIdx = (stmtBeginIdx + stepsPerPage | 0) - 1 | 0;
  var actSetStepsPerPage = function (newStepsPerPage) {
    if (1 <= newStepsPerPage && newStepsPerPage <= 300) {
      return setStepsPerPage(function (param) {
                  return newStepsPerPage;
                });
    }
    
  };
  var actGoToPage = function (pageIdx) {
    setPageIdx(function (param) {
          return pageIdx;
        });
  };
  var setHist = function (update) {
    setHistPriv(function (ht) {
          var ht$1 = update(ht);
          histSaveToLocStor(ht$1, editorId);
          return ht$1;
        });
  };
  var scheduleUnifyAllIfAllowed = function (st) {
    if (!st.preCtxData.settingsV.val.autoUnifyAll) {
      return st;
    }
    var match = st.nextAction;
    if (match !== undefined) {
      return st;
    }
    var editIsActive = MM_wrk_editor.isEditMode(st);
    var thereAreCriticalErrorsInEditor = MM_wrk_editor.editorStateHasCriticalErrors(st);
    var atLeastOneStmtIsChecked = st.checkedStmtIds.length !== 0;
    var proofStatusIsMissing = st.stmts.some(function (stmt) {
          if (stmt.typ === "P") {
            return Belt_Option.isNone(stmt.proofStatus);
          } else {
            return false;
          }
        });
    if (!editIsActive && !thereAreCriticalErrorsInEditor && !atLeastOneStmtIsChecked && proofStatusIsMissing) {
      return MM_wrk_editor.setNextAction(st, {
                  TAG: "UnifyAll",
                  nextAction: (function () {
                      
                    })
                });
    } else {
      return st;
    }
  };
  var saveStateToLocStorAndMakeHistSnapshot = function (st) {
    editorSaveStateToLocStor(st, editorId);
    setHist(function (ht) {
          return MM_editor_history.editorHistAddSnapshot(ht, st);
        });
    return st;
  };
  var setState = function (update) {
    setStatePriv(function (st) {
          var st$1 = update(st);
          var st$2 = MM_wrk_editor.verifyEditorState(st$1);
          var st$3 = saveStateToLocStorAndMakeHistSnapshot(st$2);
          return scheduleUnifyAllIfAllowed(st$3);
        });
  };
  var actUnifyAllResultsAreReady = function (proofTreeDto, nextAction) {
    if (proofTreeDto.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, "Error in UnifyAll", undefined, Caml_option.some(React.createElement(Expln_React_Column.make, {
                          children: Caml_option.some(null)
                        }, React.createElement("pre", {
                              style: {
                                color: "red"
                              }
                            }, "Error:"), React.createElement("pre", undefined, proofTreeDto._0))), undefined, (function () {
                    setStatePriv(function (st) {
                          return MM_wrk_editor.setNextAction(st, {
                                      TAG: "Action",
                                      _0: nextAction
                                    });
                        });
                  }), undefined, undefined, undefined);
    }
    var proofTreeDto$1 = proofTreeDto._0;
    setStatePriv(function (st) {
          var st$1 = MM_wrk_editor.applyUnifyAllResults(st, proofTreeDto$1);
          var st$2 = saveStateToLocStorAndMakeHistSnapshot(st$1);
          return MM_wrk_editor.setNextAction(st$2, {
                      TAG: "Action",
                      _0: nextAction
                    });
        });
  };
  var showInfoMsg = function (title, text) {
    MM_react_common.openInfoDialog(modalRef, title, undefined, undefined, text, undefined, undefined, undefined, undefined);
  };
  var showErrMsg = function (title, text) {
    MM_react_common.openInfoDialog(modalRef, title, Caml_option.some(React.createElement("span", {
                  style: {
                    color: "red"
                  }
                }, React.createElement(PriorityHigh, {}))), undefined, text, undefined, undefined, undefined, undefined);
  };
  var editIsActive = MM_wrk_editor.isEditMode(state);
  var thereAreCriticalErrorsInEditor = MM_wrk_editor.editorStateHasCriticalErrors(state);
  var thereAreAnyErrorsInEditor = MM_wrk_editor.editorStateHasAnyErrors(state);
  var atLeastOneStmtIsChecked = state.checkedStmtIds.length !== 0;
  var atLeastOneStmtHasSelectedText = Belt_Option.isSome(state.stmts.find(function (stmt) {
            return MM_wrk_editor.hasSelectedText(stmt.cont);
          }));
  var checkedStmtIds = state.checkedStmtIds.map(function (param) {
        return param[0];
      });
  var allCheckedStmtsAreBookmarked = state.stmts.every(function (stmt) {
        if (checkedStmtIds.includes(stmt.id)) {
          return stmt.isBkm;
        } else {
          return true;
        }
      });
  var allCheckedStmtsAreUnbookmarked = state.stmts.every(function (stmt) {
        if (checkedStmtIds.includes(stmt.id)) {
          return !stmt.isBkm;
        } else {
          return true;
        }
      });
  var atLeastOneStmtIsNotChecked = state.stmts.length !== state.checkedStmtIds.length;
  var mainCheckboxState = (atLeastOneStmtIsChecked || atLeastOneStmtHasSelectedText) && atLeastOneStmtIsNotChecked ? undefined : (
      atLeastOneStmtIsChecked && !atLeastOneStmtIsNotChecked ? true : false
    );
  var generalModificationActionIsEnabled = !editIsActive && !thereAreCriticalErrorsInEditor;
  var numOfCheckedStmts = state.checkedStmtIds.length;
  var thereIsDuplicatedStmt = MM_wrk_editor.editorStateHasDuplicatedStmts(state);
  var actPreCtxDataUpdated = function () {
    setState(function (st) {
          var st$1 = MM_wrk_editor.setPreCtxData(st, preCtxData);
          return MM_wrk_editor.setNextAction(st$1, {
                      TAG: "Action",
                      _0: (function () {
                          
                        })
                    });
        });
    setHist(function (__x) {
          return MM_editor_history.editorHistSetMaxLength(__x, preCtxData.settingsV.val.editorHistMaxLength);
        });
  };
  React.useEffect((function () {
          actPreCtxDataUpdated();
        }), [
        preCtxData.settingsV.ver,
        preCtxData.ctxV.ver
      ]);
  var actOpenMainMenu = function () {
    setMainMenuIsOpened(function (param) {
          return true;
        });
  };
  var actCloseMainMenu = function () {
    setMainMenuIsOpened(function (param) {
          return false;
        });
  };
  var actAddNewStmt = function () {
    setState(function (st) {
          return MM_wrk_editor.addNewStmt(st, undefined, showBkmOnly)[0];
        });
  };
  var actDeleteCheckedStmts = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    var numOfSelectedStmts = state.checkedStmtIds.length;
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, numOfSelectedStmts === state.stmts.length ? "Delete all steps?" : (
                                            numOfSelectedStmts === 1 ? "Delete the selected step?" : "Delete " + String(state.checkedStmtIds.length) + " selected steps?"
                                          ), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  children: "Cancel"
                                                }), React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(MM_wrk_editor.deleteCheckedStmts);
                                                    }),
                                                  variant: "contained",
                                                  children: "Delete"
                                                }))))
                              });
                  }));
          }));
  };
  var actToggleMainCheckbox = function () {
    var action = mainCheckboxState !== undefined && !mainCheckboxState ? MM_wrk_editor.checkAllStmts : MM_wrk_editor.uncheckAllStmts;
    setStatePriv(function (st) {
          var st$1 = action(st);
          return scheduleUnifyAllIfAllowed(st$1);
        });
  };
  var actMoveCheckedStmtsUp = function () {
    if (showBkmOnly) {
      return setState(function (__x) {
                  return MM_wrk_editor.moveCheckedBookmarkedStmts(__x, true);
                });
    } else {
      return setState(function (__x) {
                  return MM_wrk_editor.moveCheckedStmts(__x, true);
                });
    }
  };
  var actMoveCheckedStmtsDown = function () {
    if (showBkmOnly) {
      return setState(function (__x) {
                  return MM_wrk_editor.moveCheckedBookmarkedStmts(__x, false);
                });
    } else {
      return setState(function (__x) {
                  return MM_wrk_editor.moveCheckedStmts(__x, false);
                });
    }
  };
  var actBookmarkCheckedStmts = function () {
    setStatePriv(function (st) {
          var st$1 = MM_wrk_editor.bookmarkCheckedStmts(st, true);
          return saveStateToLocStorAndMakeHistSnapshot(st$1);
        });
  };
  var actUnbookmarkCheckedStmts = function () {
    setStatePriv(function (st) {
          var st$1 = MM_wrk_editor.bookmarkCheckedStmts(st, false);
          return saveStateToLocStorAndMakeHistSnapshot(st$1);
        });
  };
  var actDuplicateStmt = function (top) {
    setState(function (st) {
          var st$1 = MM_wrk_editor.duplicateCheckedStmt(st, top, showBkmOnly ? true : undefined);
          return MM_wrk_editor.uncheckAllStmts(st$1);
        });
  };
  var addStmtAbove = function (st, id, text, isBkm) {
    var st$1 = MM_wrk_editor.uncheckAllStmts(st);
    var st$2 = MM_wrk_editor.toggleStmtChecked(st$1, id);
    var match = MM_wrk_editor.addNewStmt(st$2, undefined, isBkm);
    return MM_wrk_editor.setStmtCont(match[0], match[1], MM_wrk_editor.strToCont(text, undefined, undefined));
  };
  var actBeginEdit0 = function (setter) {
    if (editIsActive) {
      return MM_react_common.openInfoDialog(modalRef, previousEditingIsNotCompletedTitle, undefined, undefined, previousEditingIsNotCompletedText, undefined, undefined, undefined, undefined);
    } else {
      return setState(setter);
    }
  };
  var actBeginEdit = function (setter, stmtId) {
    if (editIsActive) {
      return MM_react_common.openInfoDialog(modalRef, previousEditingIsNotCompletedTitle, undefined, undefined, previousEditingIsNotCompletedText, undefined, undefined, undefined, undefined);
    } else {
      return setState(function (__x) {
                  return setter(__x, stmtId);
                });
    }
  };
  var actDescrEditComplete = function (newText) {
    setState(function (__x) {
          return MM_wrk_editor.completeDescrEditMode(__x, newText);
        });
  };
  var actVarsEditComplete = function (newText) {
    setState(function (__x) {
          return MM_wrk_editor.completeVarsEditMode(__x, newText);
        });
  };
  var actDisjEditComplete = function (newText) {
    setState(function (__x) {
          return MM_wrk_editor.completeDisjEditMode(__x, newText);
        });
  };
  var actCompleteEditLabel = function (stmtId, newLabel) {
    var newLabel$1 = newLabel.trim();
    var msg = MM_wrk_editor.renameStmt(state, stmtId, newLabel$1);
    if (msg.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, "Cannot rename this step: " + msg._0, undefined, undefined, undefined, undefined);
    }
    var st = msg._0;
    setState(function (param) {
          return MM_wrk_editor.completeLabelEditMode(st, stmtId, newLabel$1);
        });
  };
  var actToggleParenAc = function () {
    setParenAc(function (prev) {
          return !prev;
        });
  };
  var addNewStatementsPriv = function (st, stmtsDto) {
    return MM_wrk_editor.addNewStatements(st, stmtsDto, showBkmOnlyRef.current);
  };
  var actAddAsrtByLabel = function (asrtLabel) {
    return new Promise((function (resolve, param) {
                  setState(function (st) {
                        if (MM_wrk_editor.editorStateHasCriticalErrors(st)) {
                          resolve({
                                TAG: "Error",
                                _0: "The target editor has errors. Please fix them before adding new steps."
                              });
                          return st;
                        }
                        if (MM_wrk_editor.isEditMode(st)) {
                          resolve({
                                TAG: "Error",
                                _0: "The target editor is in the edit mode. Please complete editing before adding new steps."
                              });
                          return st;
                        }
                        var wrkCtx = st.wrkCtx;
                        if (wrkCtx !== undefined) {
                          var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
                          var frame = MM_context.getFrame(wrkCtx$1, asrtLabel);
                          if (frame !== undefined) {
                            var st$1 = addNewStatementsPriv(st, MM_wrk_search_asrt.frameToStmtsDto(wrkCtx$1, frame));
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                            return st$1;
                          }
                          resolve({
                                TAG: "Error",
                                _0: "Cannot find a frame by name '" + asrtLabel + "'"
                              });
                          return st;
                        }
                        resolve({
                              TAG: "Error",
                              _0: "MM context is not loaded."
                            });
                        return st;
                      });
                }));
  };
  React.useEffect((function () {
          addAsrtByLabel.contents = actAddAsrtByLabel;
          updateTabTitle.contents = (function (newTabTitle) {
              setStatePriv(function (st) {
                    var st_preCtxData = st.preCtxData;
                    var st_descr = st.descr;
                    var st_descrEditMode = st.descrEditMode;
                    var st_varsText = st.varsText;
                    var st_varsEditMode = st.varsEditMode;
                    var st_varsErr = st.varsErr;
                    var st_wrkCtxColors = st.wrkCtxColors;
                    var st_disjText = st.disjText;
                    var st_disjEditMode = st.disjEditMode;
                    var st_disjErr = st.disjErr;
                    var st_wrkCtx = st.wrkCtx;
                    var st_nextStmtId = st.nextStmtId;
                    var st_stmts = st.stmts;
                    var st_checkedStmtIds = st.checkedStmtIds;
                    var st_nextAction = st.nextAction;
                    var st$1 = {
                      preCtxData: st_preCtxData,
                      tabTitle: newTabTitle,
                      descr: st_descr,
                      descrEditMode: st_descrEditMode,
                      varsText: st_varsText,
                      varsEditMode: st_varsEditMode,
                      varsErr: st_varsErr,
                      wrkCtxColors: st_wrkCtxColors,
                      disjText: st_disjText,
                      disjEditMode: st_disjEditMode,
                      disjErr: st_disjErr,
                      wrkCtx: st_wrkCtx,
                      nextStmtId: st_nextStmtId,
                      stmts: st_stmts,
                      checkedStmtIds: st_checkedStmtIds,
                      nextAction: st_nextAction
                    };
                    editorSaveStateToLocStor(st$1, editorId);
                    return st$1;
                  });
            });
        }), []);
  var actRestorePrevState = function (histIdx) {
    var msg = MM_editor_history.restoreEditorStateFromSnapshot(state, hist, histIdx);
    if (msg.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, "Could not restore editor state", undefined, undefined, msg._0, undefined, undefined, undefined, undefined);
    }
    var editorState = msg._0;
    setState(function (param) {
          return MM_wrk_editor.recalcWrkColors(editorState);
        });
  };
  var viewOptions = {
    showCheckbox: showCheckbox,
    showLabel: showLabel,
    showType: showType,
    showJstf: showJstf,
    inlineMode: inlineMode,
    smallBtns: smallBtns
  };
  var actOpenRestorePrevStateDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModalFullScreen(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_editor_hist.make, {
                                modalRef: modalRef,
                                editorState: MM_wrk_editor.removeAllTempData(state),
                                hist: hist,
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                viewOptions: viewOptions,
                                stepsPerPage: stepsPerPage,
                                onRestore: (function (histIdx) {
                                    actRestorePrevState(histIdx);
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actMergeStmts = function () {
    var msg = MM_wrk_editor.findStmtsToMerge(state);
    if (msg.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, msg._0, undefined, undefined, undefined, undefined);
    }
    var match = msg._0;
    var stmt2 = match[1];
    var stmt1 = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_merge_two_stmts.make, {
                                stmt1: stmt1,
                                stmt2: stmt2,
                                onCancel: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onStmtSelected: (function (stmtToUse, stmtToRemove) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    var continueMergingStmts = numOfCheckedStmts === 0;
                                    setState(function (st) {
                                          var st$1 = MM_wrk_editor.mergeStmts(st, stmtToUse.id, stmtToRemove.id);
                                          if (st$1.TAG === "Ok") {
                                            var st$2 = MM_wrk_editor.uncheckAllStmts(st$1._0);
                                            if (!continueMergingStmts) {
                                              return st$2;
                                            }
                                            var st$3 = MM_wrk_editor.verifyEditorState(st$2);
                                            if (MM_wrk_editor.editorStateHasDuplicatedStmts(st$3)) {
                                              return MM_wrk_editor.setNextAction(st$3, "MergeNextDuplicate");
                                            } else {
                                              return st$3;
                                            }
                                          }
                                          MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, st$1._0, undefined, undefined, undefined, undefined);
                                          return st;
                                        });
                                  })
                              });
                  }));
          }));
  };
  var actSearchAsrt = function () {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_search_asrt.make, {
                                modalRef: modalRef,
                                preCtxData: state.preCtxData,
                                wrkCtx: wrkCtx$1,
                                initialTyp: getLastUsedTyp(state.preCtxData.ctxV.val.min),
                                onTypChange: (function (__x) {
                                    saveLastUsedTyp(state.preCtxData.ctxV.val.min, __x);
                                  }),
                                onCanceled: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onResultsSelected: (function (selectedLabels) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    var wrkCtx = state.wrkCtx;
                                    if (wrkCtx === undefined) {
                                      return showErrMsg(undefined, "MM context is not loaded.");
                                    }
                                    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
                                    var msg = Core__Array.reduce(selectedLabels, {
                                          TAG: "Ok",
                                          _0: []
                                        }, (function (res, label) {
                                            if (res.TAG !== "Ok") {
                                              return res;
                                            }
                                            var selectedFrames = res._0;
                                            var frame = MM_context.getFrame(wrkCtx$1, label);
                                            if (frame !== undefined) {
                                              selectedFrames.push(frame);
                                              return {
                                                      TAG: "Ok",
                                                      _0: selectedFrames
                                                    };
                                            } else {
                                              return {
                                                      TAG: "Error",
                                                      _0: "Internal error: cannot find a frame by label '" + label + "'"
                                                    };
                                            }
                                          }));
                                    if (msg.TAG !== "Ok") {
                                      return showErrMsg(undefined, msg._0);
                                    }
                                    var selectedFrames = msg._0;
                                    setState(function (st) {
                                          return Core__Array.reduce(selectedFrames, st, (function (st, frame) {
                                                        return addNewStatementsPriv(st, MM_wrk_search_asrt.frameToStmtsDto(wrkCtx$1, frame));
                                                      }));
                                        });
                                  })
                              });
                  }));
          }));
  };
  var getSelectionText = function (stmt) {
    var match = stmt.cont;
    if (match.TAG === "Text") {
      return ;
    }
    var clickedNodeId = match._0.clickedNodeId;
    if (clickedNodeId === undefined) {
      return ;
    }
    var time = clickedNodeId[1];
    return Belt_Option.map(MM_wrk_editor.getSelectedText(stmt.cont), (function (str) {
                  return [
                          str,
                          time
                        ];
                }));
  };
  var getExprsToSubstitute = function (st) {
    var selections = Expln_utils_common.sortInPlaceWith(st.stmts.map(function (stmt) {
                  var res = getSelectionText(stmt);
                  if (res !== undefined) {
                    return res;
                  } else {
                    return Belt_Option.map(st.checkedStmtIds.find(function (param) {
                                    return param[0] === stmt.id;
                                  }), (function (param) {
                                  return [
                                          MM_wrk_editor.contToStr(stmt.cont),
                                          param[1]
                                        ];
                                }));
                  }
                }).filter(Belt_Option.isSome).map(Belt_Option.getExn), (function (param, param$1) {
            return Common.compareDates(param[1], param$1[1]);
          }));
    var len = selections.length;
    var sel1 = Belt_Option.map(Belt_Array.get(selections, len - 2 | 0), (function (param) {
            return param[0];
          }));
    var sel2 = Belt_Option.map(Belt_Array.get(selections, len - 1 | 0), (function (param) {
            return param[0];
          }));
    if (len !== 0) {
      if (len !== 1) {
        return [
                sel1,
                sel2
              ];
      } else {
        return [
                sel2,
                undefined
              ];
      }
    } else {
      return [
              undefined,
              undefined
            ];
    }
  };
  var actSubstitute = function () {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var match = getExprsToSubstitute(state);
    var expr2Init = match[1];
    var expr1Init = match[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_substitution.make, {
                                modalRef: modalRef,
                                editorState: state,
                                expr1Init: expr1Init,
                                expr2Init: expr2Init,
                                wrkCtx: wrkCtx$1,
                                onCanceled: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  }),
                                onSubstitutionSelected: (function (wrkSubs) {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                    setState(function (st) {
                                          return MM_wrk_editor_substitution.applySubstitutionForEditor(st, wrkSubs);
                                        });
                                  })
                              });
                  }));
          }));
  };
  onOpenSubstitutionDialogRef.current = actSubstitute;
  var makeActTerminate = function (modalId) {
    return function () {
      MM_wrk_client.terminateWorker();
      Expln_React_Modal.closeModal(modalRef, modalId);
    };
  };
  var prepareArgs0 = function (argLabels, rootStmts) {
    return rootStmts.filter(function (stmt) {
                  return argLabels.includes(stmt.label);
                }).map(function (stmt) {
                return stmt.expr;
              });
  };
  var getArgs0AndAsrtLabel = function (checkedStmts, rootStmts) {
    if (checkedStmts.length === 0 || checkedStmts[checkedStmts.length - 1 | 0].typ !== "P") {
      return ;
    }
    var stmtToProve = checkedStmts[checkedStmts.length - 1 | 0];
    var match = MM_wrk_editor.parseJstf(stmtToProve.jstfText);
    if (match.TAG === "Ok") {
      var match$1 = match._0;
      if (match$1 !== undefined) {
        return [
                prepareArgs0(match$1.args, rootStmts),
                match$1.label
              ];
      }
      
    }
    if (checkedStmts.length === 1) {
      return ;
    } else {
      return [
              prepareArgs0(checkedStmts.slice(0, checkedStmts.length - 1 | 0).map(function (stmt) {
                        return stmt.label;
                      }), rootStmts),
              undefined
            ];
    }
  };
  var shouldCloseBottomUpProverDialog = function (isApiCall, selectFirstFoundProof, selectedResult) {
    if (!isApiCall || Core__Option.getOr(selectFirstFoundProof, false) || Core__Option.isNone(selectFirstFoundProof) && selectedResult !== undefined && selectedResult.TAG === "Ok") {
      return true;
    } else {
      return false;
    }
  };
  var actBottomUpResultSelected = function (selectedResult, bottomUpProofResultConsumer) {
    if (selectedResult === undefined) {
      return bottomUpProofResultConsumer(undefined);
    }
    if (selectedResult.TAG !== "Ok") {
      return bottomUpProofResultConsumer({
                  TAG: "Error",
                  _0: selectedResult._0
                });
    }
    var selectedResult$1 = selectedResult._0;
    setState(function (st) {
          var st$1 = MM_wrk_editor.addNewStatements(st, selectedResult$1, showBkmOnly);
          var st$2 = MM_wrk_editor.uncheckAllStmts(st$1);
          return MM_wrk_editor.setNextAction(st$2, {
                      TAG: "UnifyAll",
                      nextAction: (function () {
                          bottomUpProofResultConsumer({
                                TAG: "Ok",
                                _0: selectedResult$1
                              });
                        })
                    });
        });
  };
  var actUnify = function (stmtId, params, initialDebugLevel, isApiCallOpt, delayBeforeStartMsOpt, selectFirstFoundProof, bottomUpProofResultConsumerOpt, nextActionOpt) {
    var isApiCall = isApiCallOpt !== undefined ? isApiCallOpt : false;
    var delayBeforeStartMs = delayBeforeStartMsOpt !== undefined ? delayBeforeStartMsOpt : 0;
    var bottomUpProofResultConsumer = bottomUpProofResultConsumerOpt !== undefined ? bottomUpProofResultConsumerOpt : (function (param) {
          
        });
    var nextAction = nextActionOpt !== undefined ? nextActionOpt : (function () {
          
        });
    if (thereAreCriticalErrorsInEditor) {
      return ;
    }
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return ;
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var varsText = state.varsText;
    var disjText = state.disjText;
    var state$1;
    if (stmtId !== undefined) {
      var state$2 = MM_wrk_editor.uncheckAllStmts(state);
      state$1 = MM_wrk_editor.toggleStmtChecked(state$2, stmtId);
    } else {
      state$1 = state;
    }
    var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(state$1);
    var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
    var checkedStmtIds = Belt_HashSetString.fromArray(state$1.checkedStmtIds.map(function (param) {
              return param[0];
            }));
    var checkedStmts = state$1.stmts.filter(function (stmt) {
          return Belt_HashSetString.has(checkedStmtIds, stmt.id);
        });
    var settings = state$1.preCtxData.settingsV.val;
    if (checkedStmts.length > 0 && checkedStmts[checkedStmts.length - 1 | 0].typ === "P") {
      var initialParams;
      if (params !== undefined) {
        initialParams = params;
      } else {
        var match = getArgs0AndAsrtLabel(checkedStmts, rootStmts);
        if (match !== undefined) {
          var bottomUpProverDefaults = preCtxData.settingsV.val.bottomUpProverDefaults;
          initialParams = MM_bottom_up_prover_params.bottomUpProverParamsMakeDefault(match[1], bottomUpProverDefaults.searchDepth, Core__Option.getOr(MM_bottom_up_prover_params.lengthRestrictFromStr(bottomUpProverDefaults.lengthRestrict), "Less"), bottomUpProverDefaults.allowNewDisjForExistingVars, bottomUpProverDefaults.allowNewStmts, bottomUpProverDefaults.allowNewVars, match[0], undefined, undefined);
        } else {
          initialParams = undefined;
        }
      }
      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                  return null;
                })), (function (modalId) {
              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                      return React.createElement(MM_cmp_unify_bottom_up.make, {
                                  modalRef: modalRef,
                                  settingsVer: state$1.preCtxData.settingsV.ver,
                                  settings: settings,
                                  preCtxVer: state$1.preCtxData.ctxV.ver,
                                  preCtx: state$1.preCtxData.ctxV.val.min,
                                  frms: state$1.preCtxData.frms,
                                  parenCnt: state$1.preCtxData.parenCnt,
                                  varsText: varsText,
                                  disjText: disjText,
                                  wrkCtx: wrkCtx$1,
                                  rootStmts: rootUserStmts,
                                  reservedLabels: state$1.stmts.map(function (stmt) {
                                        return stmt.label;
                                      }),
                                  typeToPrefix: Belt_MapString.fromArray(settings.typeSettings.map(function (ts) {
                                            return [
                                                    ts.typ,
                                                    ts.prefix
                                                  ];
                                          })),
                                  initialParams: initialParams,
                                  initialDebugLevel: initialDebugLevel,
                                  apiCallStartTime: isApiCall ? Caml_option.some(new Date()) : undefined,
                                  delayBeforeStartMs: delayBeforeStartMs,
                                  selectFirstFoundProof: selectFirstFoundProof,
                                  onResultSelected: (function (newStmtsDto) {
                                      actBottomUpResultSelected(newStmtsDto, bottomUpProofResultConsumer);
                                      if (shouldCloseBottomUpProverDialog(isApiCall, selectFirstFoundProof, newStmtsDto)) {
                                        return Expln_React_Modal.closeModal(modalRef, modalId);
                                      }
                                      
                                    }),
                                  onCancel: (function () {
                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                    })
                                });
                    }));
            }));
      return ;
    }
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return MM_react_common.rndProgress("Unifying all", 0, undefined);
              })), (function (modalId) {
            var onTerminate = makeActTerminate(modalId);
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return MM_react_common.rndProgress("Unifying all", 0, onTerminate);
                  }));
            var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
            return Expln_utils_promise.promiseMap(MM_wrk_unify.unify(state$1.preCtxData.settingsV.ver, settings, state$1.preCtxData.ctxV.ver, state$1.preCtxData.ctxV.val.min, varsText, disjText, rootStmts, undefined, settings.allowedFrms, state$1.preCtxData.syntaxTypes, settings.checkSyntax ? MM_wrk_editor.getAllExprsToSyntaxCheck(state$1, rootStmts) : undefined, 0, (function (msg) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return MM_react_common.rndProgress(msg, undefined, onTerminate);
                                    }));
                            })), (function (proofTreeDto) {
                          actUnifyAllResultsAreReady(proofTreeDto, nextAction);
                          Expln_React_Modal.closeModal(modalRef, modalId);
                        }));
          }));
  };
  React.useEffect((function () {
          var action = state.nextAction;
          if (action !== undefined) {
            setStatePriv(function (__x) {
                  return MM_wrk_editor.setNextAction(__x, undefined);
                });
            if (typeof action !== "object") {
              if (MM_wrk_editor.editorStateHasDuplicatedStmts(state)) {
                actMergeStmts();
              }
              
            } else if (action.TAG === "UnifyAll") {
              actUnify(undefined, undefined, undefined, undefined, undefined, undefined, undefined, action.nextAction);
            } else {
              action._0();
            }
          }
          
        }), [state.nextAction]);
  var actExportProof = function (stmtId) {
    var match = MM_wrk_editor.generateCompressedProof(state, stmtId, false);
    if (match === undefined) {
      return ;
    }
    var proofTableWithoutTypes = match[2];
    var proofTableWithTypes = match[1];
    var proofTextReqHyps = match[0];
    var match$1 = MM_wrk_editor.generateCompressedProof(state, stmtId, true);
    if (match$1 === undefined) {
      return ;
    }
    var proofTextAllHyps = match$1[0];
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_export_proof.make, {
                                proofTextReqHyps: proofTextReqHyps,
                                proofTextAllHyps: proofTextAllHyps,
                                proofTableWithTypes: proofTableWithTypes,
                                proofTableWithoutTypes: proofTableWithoutTypes,
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var currGoalStmtStatus = Belt_Option.map(state.stmts.find(function (stmt) {
            return stmt.isGoal;
          }), (function (stmt) {
          return [
                  stmt.id,
                  MM_wrk_editor.contToStr(stmt.cont),
                  stmt.proofStatus
                ];
        }));
  var prevGoalStmtStatus = React.useRef([
        "",
        "NoJstf"
      ]);
  React.useEffect((function () {
          var match = state.nextAction;
          if (match === undefined && currGoalStmtStatus !== undefined) {
            var currGoalStatus = currGoalStmtStatus[2];
            var curGoalText = currGoalStmtStatus[1];
            if (currGoalStatus !== undefined) {
              var match$1 = prevGoalStmtStatus.current;
              if (currGoalStatus === "Ready" && (match$1[1] !== "Ready" || curGoalText !== match$1[0])) {
                actExportProof(currGoalStmtStatus[0]);
              }
              prevGoalStmtStatus.current = [
                curGoalText,
                currGoalStatus
              ];
            } else {
              prevGoalStmtStatus.current = [
                curGoalText,
                "NoJstf"
              ];
            }
          }
          
        }), [currGoalStmtStatus]);
  var actExportToJson = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_export_state_to_json.make, {
                                jsonStr: Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state)),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actExportToUrl = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_export_state_to_url.make, {
                                editorStateBase64: Common.strToSafeBase64(Expln_utils_common.stringify(MM_wrk_editor_json.editorStateToEditorStateLocStor(state))),
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actLoadEditorState = function (stateLocStor) {
    setPageIdx(function (param) {
          return 0;
        });
    var nextStmtId = Core__Option.getOr(Core__Option.map(MM_editor_history.editorHistGetMaxIntStmtId(hist), (function (i) {
                return i + 1 | 0;
              })), 0);
    var newState = MM_wrk_editor.setNextAction(MM_wrk_editor_json.createInitialEditorState(preCtxData, stateLocStor, nextStmtId), {
          TAG: "Action",
          _0: (function () {
              
            })
        });
    setState(function (param) {
          return newState;
        });
    onTabTitleChange(newState.tabTitle);
    Core__Option.forEach(reloadCtx.current, (function (reloadCtx) {
            reloadCtx(stateLocStor.srcs, state.preCtxData.settingsV.val, undefined);
          }));
  };
  var actImportFromJson = function (jsonStr) {
    var errorMsg = MM_wrk_editor_json.readEditorStateFromJsonStr(jsonStr);
    if (errorMsg.TAG === "Ok") {
      actLoadEditorState(errorMsg._0);
      return true;
    }
    var errorMsg$1 = errorMsg._0;
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          spacing: 1,
                                          children: Caml_option.some(null)
                                        }, errorMsg$1, React.createElement(Button, {
                                              onClick: (function (param) {
                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                }),
                                              variant: "contained",
                                              children: "Ok"
                                            })))
                              });
                  }));
          }));
    return false;
  };
  var actOpenImportFromJsonDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_import_from_json.make, {
                                onImport: (function (text) {
                                    if (actImportFromJson(text)) {
                                      return Expln_React_Modal.closeModal(modalRef, modalId);
                                    }
                                    
                                  }),
                                onCancel: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actShowCompletedProof = function () {
    var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state);
    if (stmt === undefined) {
      return showInfoMsg("A proof is not available", infoAboutGettingCompletedProof);
    }
    if (stmt.typ !== "P") {
      return showInfoMsg("A proof is not available", infoAboutGettingCompletedProof);
    }
    var match = stmt.proofStatus;
    if (match === "Ready") {
      return actExportProof(stmt.id);
    } else {
      return showInfoMsg("A proof is not available", infoAboutGettingCompletedProof);
    }
  };
  var makeFrameProofDataForAssertions = function (preCtxData, labels, onProgress) {
    if (Belt_SetString.size(labels) === 0) {
      return Promise.resolve({
                  TAG: "Ok",
                  _0: undefined
                });
    }
    var pctPerFrame = 1.0 / Belt_SetString.size(labels);
    var go = async function (labelsToProcess, res) {
      if (res.TAG !== "Ok") {
        return res;
      }
      var proofDatas = res._0;
      if (Belt_SetString.size(labelsToProcess) === 0) {
        return res;
      }
      var curLabel = Belt_SetString.toArray(labelsToProcess)[0];
      var msg = await MM_cmp_pe_frame_full.makeFrameProofData(preCtxData, curLabel, (function (pct) {
              var processedPct = Belt_MapString.size(proofDatas) * pctPerFrame;
              var curPct = processedPct + pctPerFrame * pct;
              onProgress(curPct);
            }));
      if (msg.TAG === "Ok") {
        return await go(Belt_SetString.remove(labelsToProcess, curLabel), {
                    TAG: "Ok",
                    _0: Belt_MapString.set(proofDatas, curLabel, msg._0)
                  });
      }
      var errMsg = "An error occured while getting proof for " + curLabel + ": " + msg._0;
      return await go(undefined, {
                  TAG: "Error",
                  _0: errMsg
                });
    };
    return go(labels, {
                TAG: "Ok",
                _0: undefined
              });
  };
  var inlineTheoremForStep = function (state, stmtId, proofData) {
    var state$1 = MM_wrk_editor.toggleStmtChecked(MM_wrk_editor.uncheckAllStmts(state), stmtId);
    var stmt = MM_wrk_editor.getTheOnlyCheckedStmt(state$1);
    if (stmt === undefined) {
      return {
              TAG: "Error",
              _0: "Internal error: cannot find the step to inline the proof for."
            };
    }
    var match = stmt.src;
    if (match === undefined) {
      return {
              TAG: "Error",
              _0: "Not a provable step."
            };
    }
    if (typeof match !== "object") {
      return {
              TAG: "Error",
              _0: "Not a provable step."
            };
    }
    if (match.TAG !== "Assertion") {
      return {
              TAG: "Error",
              _0: "Not a provable step."
            };
    }
    var label = match.label;
    var proofTreeDto = stmt.proofTreeDto;
    if (proofTreeDto === undefined) {
      return {
              TAG: "Error",
              _0: "Internal error: proofTreeDto is not set."
            };
    }
    var wrkCtx = state$1.wrkCtx;
    if (wrkCtx === undefined) {
      return {
              TAG: "Error",
              _0: "Internal error: wrkCtx is not set."
            };
    }
    var frameProofData = Belt_MapString.get(proofData, label);
    if (frameProofData === undefined) {
      return {
              TAG: "Error",
              _0: "Internal error: no proof data for label " + label + "."
            };
    }
    var msg = MM_cmp_pe_frame_full.frameProofDataToStmtsDto(preCtxData, Caml_option.valFromOption(wrkCtx), proofTreeDto, match.args, frameProofData);
    if (msg.TAG === "Ok") {
      return {
              TAG: "Ok",
              _0: MM_wrk_editor.uncheckAllStmts(MM_wrk_editor.addNewStatements(state$1, msg._0, undefined))
            };
    } else {
      return {
              TAG: "Error",
              _0: msg._0
            };
    }
  };
  var findStepToInlineProofFor = function (state, proofData, updatedLabels) {
    return state.stmts.find(function (stmt) {
                if (Belt_HashSetString.has(updatedLabels, stmt.label)) {
                  return false;
                }
                var match = stmt.src;
                if (match !== undefined && !(typeof match !== "object" || !(match.TAG === "Assertion" && Belt_MapString.has(proofData, match.label)))) {
                  return Core__Option.isSome(stmt.proofTreeDto);
                } else {
                  return false;
                }
              });
  };
  var inlineTheoremForSteps = function (state, proofData, onProcessedStepCntChange) {
    var state$1 = {
      contents: state
    };
    var errMsg;
    var stepsInlinedCnt = 0;
    onProcessedStepCntChange(stepsInlinedCnt);
    var updatedLabels = Belt_HashSetString.make(10);
    var getNextStmt = function () {
      var stmt = findStepToInlineProofFor(state$1.contents, proofData, updatedLabels);
      if (stmt !== undefined) {
        Belt_HashSetString.add(updatedLabels, stmt.label);
        return stmt;
      }
      
    };
    var stmtToInlineRef = getNextStmt();
    while(Core__Option.isSome(stmtToInlineRef) && Core__Option.isNone(errMsg)) {
      var stmtToInline = Core__Option.getExn(stmtToInlineRef, "inlineTheoremForSteps: stmtToInlineRef.contents is None.");
      var msg = inlineTheoremForStep(state$1.contents, stmtToInline.id, proofData);
      if (msg.TAG === "Ok") {
        state$1.contents = msg._0;
        stepsInlinedCnt = stepsInlinedCnt + 1 | 0;
        onProcessedStepCntChange(stepsInlinedCnt);
        stmtToInlineRef = getNextStmt();
      } else {
        errMsg = "An error happened while inlining step " + stmtToInline.label + ": " + msg._0;
      }
    };
    return [
            state$1.contents,
            errMsg
          ];
  };
  var actInlineTheorems = function () {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return showErrMsg("actInlineTheorems internal error", "wrkCtx is not set.");
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var theoremLabels = Belt_SetString.toArray(Belt_SetString.fromArray(state.stmts.map(function (stmt) {
                          var match = stmt.src;
                          if (match === undefined) {
                            return ;
                          }
                          if (typeof match !== "object") {
                            return ;
                          }
                          if (match.TAG !== "Assertion") {
                            return ;
                          }
                          var label = match.label;
                          return [
                                  label,
                                  MM_context.getTokenType(wrkCtx$1, label)
                                ];
                        }).map(function (labelData) {
                        if (labelData === undefined) {
                          return ;
                        }
                        var match = labelData[1];
                        if (match === "P") {
                          return labelData[0];
                        }
                        
                      }).filter(function (__x) {
                      return Core__Option.isSome(__x);
                    }).map(function (opt) {
                    return Core__Option.getExn(opt, "actInlineTheorems internal error: cannot map to label.");
                  }))).toSorted(Caml.string_compare);
    if (theoremLabels.length === 0) {
      return showInfoMsg(undefined, "There are no theorems in the editor.");
    } else {
      return MM_react_common.openModalPaneWithTitle(modalRef, undefined, (function (close) {
                    return React.createElement(MM_cmp_editor_select_theorems.make, {
                                modalRef: modalRef,
                                labels: theoremLabels,
                                onOk: (function (selectedLabels) {
                                    close();
                                    Expln_React_Modal.openModal(modalRef, (function () {
                                              return MM_react_common.rndProgress("Collecting proof data", 0, undefined);
                                            })).then(function (modalId) {
                                          var onTerminate = makeActTerminate(modalId);
                                          Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                  return MM_react_common.rndProgress("Collecting proof data", 0, onTerminate);
                                                }));
                                          return makeFrameProofDataForAssertions(preCtxData, Belt_SetString.fromArray(selectedLabels), (function (pct) {
                                                          Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                                  return MM_react_common.rndProgress("Collecting proof data", pct, onTerminate);
                                                                }));
                                                        })).then(function (proofData) {
                                                      if (proofData.TAG === "Ok") {
                                                        Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                                return MM_react_common.rndProgress("Inlining theorems", undefined, undefined);
                                                              }));
                                                        var match = inlineTheoremForSteps(state, proofData._0, (function (cnt) {
                                                                Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                                        return MM_react_common.rndProgress("Inlining theorems: " + cnt.toString() + " steps updated.", undefined, undefined);
                                                                      }));
                                                              }));
                                                        var errMsg = match[1];
                                                        var newState = match[0];
                                                        Expln_React_Modal.closeModal(modalRef, modalId);
                                                        return setState(function (param) {
                                                                    return {
                                                                            preCtxData: newState.preCtxData,
                                                                            tabTitle: newState.tabTitle,
                                                                            descr: newState.descr,
                                                                            descrEditMode: newState.descrEditMode,
                                                                            varsText: newState.varsText,
                                                                            varsEditMode: newState.varsEditMode,
                                                                            varsErr: newState.varsErr,
                                                                            wrkCtxColors: newState.wrkCtxColors,
                                                                            disjText: newState.disjText,
                                                                            disjEditMode: newState.disjEditMode,
                                                                            disjErr: newState.disjErr,
                                                                            wrkCtx: newState.wrkCtx,
                                                                            nextStmtId: newState.nextStmtId,
                                                                            stmts: newState.stmts,
                                                                            checkedStmtIds: newState.checkedStmtIds,
                                                                            nextAction: Core__Option.map(errMsg, (function (errMsg) {
                                                                                    return {
                                                                                            TAG: "Action",
                                                                                            _0: (function () {
                                                                                                showErrMsg("Inline theorems", errMsg);
                                                                                              })
                                                                                          };
                                                                                  }))
                                                                          };
                                                                  });
                                                      }
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      showInfoMsg("Cannot inline theorems", proofData._0);
                                                    });
                                        });
                                  }),
                                onCancel: (function () {
                                    close();
                                  })
                              });
                  }));
    }
  };
  var actDeleteUnrelatedSteps = function (deleteHyps) {
    var state$1 = MM_wrk_editor.deleteUnrelatedSteps(state, state.checkedStmtIds.map(function (param) {
              return param[0];
            }), deleteHyps);
    if (state$1.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, state$1._0, undefined, undefined, undefined, undefined);
    }
    var state$2 = state$1._0;
    setState(function (param) {
          return state$2;
        });
  };
  var actRenumberSteps = function () {
    var state$1 = MM_wrk_editor.renumberProvableSteps(state);
    if (state$1.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, state$1._0, undefined, undefined, undefined, undefined);
    }
    var state$2 = state$1._0;
    setState(function (param) {
          return state$2;
        });
  };
  var actRenameHypotheses = function () {
    var goalStmt = state.stmts.find(function (stmt) {
          return stmt.isGoal;
        });
    if (goalStmt === undefined) {
      return MM_react_common.openInfoDialog(modalRef, "Cannot rename hypotheses", undefined, undefined, "The goal step is not set. Please mark one of the steps as the goal step.", undefined, undefined, undefined, undefined);
    }
    var state$1 = MM_wrk_editor.renumberHypothesisSteps(state, goalStmt.label);
    if (state$1.TAG !== "Ok") {
      return MM_react_common.openInfoDialog(modalRef, undefined, undefined, undefined, state$1._0, undefined, undefined, undefined, undefined);
    }
    var state$2 = state$1._0;
    setState(function (param) {
          return state$2;
        });
  };
  var actOpenMoveStepsDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(Paper, {
                                style: {
                                  padding: "10px"
                                },
                                children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                                          children: Caml_option.some(null)
                                        }, React.createElement(List, {
                                              disablePadding: true,
                                              children: Caml_option.some(null)
                                            }, React.createElement(ListItem, {
                                                  disablePadding: true,
                                                  children: Caml_option.some(React.createElement(ListItemButton, {
                                                            onClick: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                setState(MM_wrk_editor.moveCheckedStmtsToTop);
                                                              }),
                                                            children: Caml_option.some(React.createElement(ListItemText, {
                                                                      children: "Move selected steps to the top"
                                                                    }))
                                                          }))
                                                }), React.createElement(ListItem, {
                                                  disablePadding: true,
                                                  children: Caml_option.some(React.createElement(ListItemButton, {
                                                            onClick: (function (param) {
                                                                Expln_React_Modal.closeModal(modalRef, modalId);
                                                                setState(MM_wrk_editor.moveCheckedStmtsToBottom);
                                                              }),
                                                            children: Caml_option.some(React.createElement(ListItemText, {
                                                                      children: "Move selected steps to the bottom"
                                                                    }))
                                                          }))
                                                })), React.createElement(Expln_React_Row.make, {
                                              children: Caml_option.some(null)
                                            }, React.createElement(Button, {
                                                  onClick: (function (param) {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    }),
                                                  variant: "outlined",
                                                  children: "Cancel"
                                                }), MM_react_common.rndHiddenTextField(undefined, MM_react_common.kbrdHnds([MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            }))])))))
                              });
                  }));
          }));
  };
  var actOpenViewOptionsDialog = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    return React.createElement(MM_cmp_editor_view_options.make, {
                                showCheckbox: showCheckbox,
                                onShowCheckboxChange: (function (b) {
                                    setShowCheckbox(function (param) {
                                          return b;
                                        });
                                  }),
                                showLabel: showLabel,
                                onShowLabelChange: (function (b) {
                                    setShowLabel(function (param) {
                                          return b;
                                        });
                                  }),
                                showType: showType,
                                onShowTypeChange: (function (b) {
                                    setShowType(function (param) {
                                          return b;
                                        });
                                  }),
                                showJstf: showJstf,
                                onShowJstfChange: (function (b) {
                                    setShowJstf(function (param) {
                                          return b;
                                        });
                                  }),
                                inlineMode: inlineMode,
                                onInlineModeChange: (function (b) {
                                    setInlineMode(function (param) {
                                          return b;
                                        });
                                  }),
                                smallBtns: smallBtns,
                                onSmallBtnsChange: (function (b) {
                                    setSmallBtns(function (param) {
                                          return b;
                                        });
                                  }),
                                stepsPerPage: stepsPerPage,
                                onStepsPerPageChange: actSetStepsPerPage,
                                onClose: (function () {
                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                  })
                              });
                  }));
          }));
  };
  var actRenameThisTab = function () {
    MM_react_common.openModalPaneWithTitle(modalRef, "Rename tab", (function (close) {
            return React.createElement(MM_cmp_rename_tab.make, {
                        initName: state.tabTitle,
                        onOk: (function (newName) {
                            close();
                            onTabTitleChange(newName);
                          }),
                        onCancel: close
                      });
          }));
  };
  var rndError = function (msgOpt, color) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: color,
                    whiteSpace: "pre-wrap"
                  }
                }, msgOpt);
    } else {
      return React.createElement(React.Fragment, {});
    }
  };
  var rndMainMenu = function () {
    if (!mainMenuIsOpened) {
      return null;
    }
    var mainMenuButtonRef$1 = mainMenuButtonRef.current;
    if (mainMenuButtonRef$1 == null) {
      return null;
    } else {
      return React.createElement(Expln_React_Menu.make, {
                  opn: true,
                  anchorEl: Caml_option.some(mainMenuButtonRef$1),
                  onClose: actCloseMainMenu,
                  children: Caml_option.some(null)
                }, React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          setShowTabs(!showTabs);
                        }),
                      children: Caml_option.some(showTabs ? "Hide tabs" : "Show tabs")
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          Belt_Option.forEach(Caml_option.nullable_to_opt(toggleCtxSelector.current), (function (toggleCtxSelector) {
                                  toggleCtxSelector();
                                }));
                        }),
                      children: Caml_option.some(ctxSelectorIsExpanded ? "Hide context" : "Show context")
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actRenameThisTab();
                        }),
                      children: "Rename this tab"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actOpenViewOptionsDialog();
                        }),
                      children: "View options"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actExportToUrl();
                        }),
                      children: "Export to URL"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actExportToJson();
                        }),
                      children: "Export to JSON"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actOpenImportFromJsonDialog();
                        }),
                      children: "Import from JSON ..."
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          setState(MM_wrk_editor.resetEditorContent);
                        }),
                      children: "Reset editor content"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actShowCompletedProof();
                        }),
                      children: "Show completed proof"
                    }), React.createElement(MenuItem, {
                      disabled: Core__Option.isNone(state.wrkCtx),
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actInlineTheorems();
                        }),
                      children: "Inline theorems"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actDeleteUnrelatedSteps(false);
                        }),
                      children: "Delete unrelated steps"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actDeleteUnrelatedSteps(true);
                        }),
                      children: "Delete unrelated steps and hypotheses"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actOpenMoveStepsDialog();
                        }),
                      children: "Move steps"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          setState(MM_wrk_editor.reorderSteps);
                        }),
                      children: "Reorder steps"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actRenameHypotheses();
                        }),
                      children: "Rename hypotheses"
                    }), React.createElement(MenuItem, {
                      onClick: (function () {
                          setMainMenuIsOpened(function (param) {
                                return false;
                              });
                          actRenumberSteps();
                        }),
                      children: "Renumber steps"
                    }));
    }
  };
  var actToggleShowBkmOnly = function () {
    setShowBkmOnly(function (prev) {
          return !prev;
        });
    setStatePriv(MM_wrk_editor.uncheckAllStmts);
  };
  var actOpenMacros = function () {
    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                return null;
              })), (function (modalId) {
            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                    var closeDialog = function () {
                      Expln_React_Modal.closeModal(modalRef, modalId);
                    };
                    return React.createElement(MM_cmp_macros.make, {
                                modalRef: modalRef,
                                onClose: closeDialog
                              });
                  }));
          }));
  };
  var rndButtons = function () {
    return React.createElement(Paper, {
                children: Caml_option.some(React.createElement(Expln_React_Row.make, {
                          spacing: 0,
                          childXsOffset: (function (idx) {
                              if (idx !== 16) {
                                return ;
                              } else {
                                return "auto";
                              }
                            }),
                          children: Caml_option.some(null)
                        }, React.createElement(Checkbox, {
                              style: smallBtns ? ({
                                    padding: "2px"
                                  }) : undefined,
                              disabled: editIsActive,
                              indeterminate: Belt_Option.isNone(mainCheckboxState),
                              checked: Belt_Option.getWithDefault(mainCheckboxState, false),
                              onChange: (function (param) {
                                  actToggleMainCheckbox();
                                })
                            }), rndIconButton(React.createElement(BookmarkAddOutlined, {}), actBookmarkCheckedStmts, !editIsActive && atLeastOneStmtIsChecked && !allCheckedStmtsAreBookmarked, undefined, "Bookmark selected steps", smallBtns), rndIconButton(React.createElement(BookmarkRemoveOutlined, {}), actUnbookmarkCheckedStmts, !editIsActive && atLeastOneStmtIsChecked && !allCheckedStmtsAreUnbookmarked, undefined, "Unbookmark selected steps", smallBtns), rndIconButton(showBkmOnly ? React.createElement(Bookmark, {}) : React.createElement(BookmarkBorder, {}), actToggleShowBkmOnly, true, undefined, "Show bookmarked steps only / show all steps", smallBtns), rndIconButton(React.createElement(ArrowDownward, {}), actMoveCheckedStmtsDown, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, false), undefined, "Move selected steps down", smallBtns), rndIconButton(React.createElement(ArrowUpward, {}), actMoveCheckedStmtsUp, !editIsActive && MM_wrk_editor.canMoveCheckedStmts(state, true), undefined, "Move selected steps up", smallBtns), rndIconButton(React.createElement(Add, {}), actAddNewStmt, !editIsActive, undefined, "Add new step (and place before selected steps if any)", smallBtns), rndIconButton(React.createElement(DeleteForever, {}), actDeleteCheckedStmts, !editIsActive && atLeastOneStmtIsChecked, undefined, "Delete selected steps", smallBtns), rndIconButton(React.createElement(Logout, {
                                  style: {
                                    transform: "rotate(-90deg)"
                                  }
                                }), (function () {
                                actDuplicateStmt(true);
                              }), !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), undefined, "Duplicate selected step up", smallBtns), rndIconButton(React.createElement(Logout, {
                                  style: {
                                    transform: "rotate(+90deg)"
                                  }
                                }), (function () {
                                actDuplicateStmt(false);
                              }), !editIsActive && MM_wrk_editor.isSingleStmtChecked(state), undefined, "Duplicate selected step down", smallBtns), rndIconButton(React.createElement(Restore, {}), actOpenRestorePrevStateDialog, !editIsActive, undefined, "Restore previous state", smallBtns), rndIconButton(React.createElement(MergeType, {
                                  style: {
                                    transform: "rotate(180deg)"
                                  }
                                }), actMergeStmts, numOfCheckedStmts === 1 || thereIsDuplicatedStmt, undefined, "Merge two similar steps", smallBtns), rndIconButton(React.createElement(Search, {}), actSearchAsrt, generalModificationActionIsEnabled && MM_substitution.frmsSize(state.preCtxData.frms) > 0, undefined, "Add new steps from existing assertions (and place before selected steps if any)", smallBtns), rndIconButton(React.createElement(TextRotationNone, {}), actSubstitute, generalModificationActionIsEnabled, undefined, "Apply a substitution to all steps", smallBtns), rndIconButton(React.createElement(Hub, {}), (function () {
                                actUnify(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
                              }), generalModificationActionIsEnabled && state.stmts.length > 0, undefined, "Unify all steps or unify selected provable bottom-up", smallBtns), rndIconButton(React.createElement(PlayArrow, {}), actOpenMacros, !editIsActive, undefined, "Run a macro", smallBtns), rndIconButton(React.createElement(Menu, {}), actOpenMainMenu, !editIsActive, Caml_option.some(mainMenuButtonRef), "Additional actions", smallBtns)))
              });
  };
  var rndErrors = function (stmt) {
    if (Belt_Option.isSome(stmt.stmtErr) || Belt_Option.isSome(stmt.syntaxErr) || Belt_Option.isSome(stmt.unifErr)) {
      return React.createElement(Expln_React_Column.make, {
                  style: {
                    marginLeft: "10px"
                  },
                  children: Caml_option.some(null)
                }, rndError(Belt_Option.map(stmt.stmtErr, (function (err) {
                            return err.msg;
                          })), "red"), rndError(Belt_Option.map(stmt.syntaxErr, (function (msg) {
                            if (msg === "") {
                              return "Syntax error.";
                            } else {
                              return "Syntax error - " + msg + ".";
                            }
                          })), "red"), rndError(stmt.unifErr, "darkgrey"));
    } else {
      return React.createElement(React.Fragment, {});
    }
  };
  var rndStmt = function (stmt) {
    var settings = state.preCtxData.settingsV.val;
    return React.createElement(MM_cmp_user_stmt.make, {
                modalRef: modalRef,
                settingsVer: state.preCtxData.settingsV.ver,
                settings: settings,
                preCtxVer: state.preCtxData.ctxV.ver,
                varsText: state.varsText,
                wrkCtx: state.wrkCtx,
                frms: state.preCtxData.frms,
                parenCnt: state.preCtxData.parenCnt,
                syntaxTypes: state.preCtxData.syntaxTypes,
                parensMap: state.preCtxData.parensMap,
                typeColors: state.preCtxData.typeColors,
                preCtxColors: state.preCtxData.symColors,
                wrkCtxColors: state.wrkCtxColors,
                editStmtsByLeftClick: settings.editStmtsByLeftClick,
                longClickEnabled: settings.longClickEnabled,
                longClickDelayMs: settings.longClickDelayMs,
                defaultStmtType: settings.defaultStmtType,
                showVisByDefault: settings.showVisByDefault,
                viewOptions: viewOptions,
                readOnly: false,
                parenAc: parenAc,
                toggleParenAc: actToggleParenAc,
                stmt: stmt,
                onLabelEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setLabelEditMode, stmt.id);
                  }),
                onLabelEditDone: (function (newLabel) {
                    actCompleteEditLabel(stmt.id, newLabel);
                  }),
                onLabelEditCancel: (function (newLabel) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var textOld = stmt$1.label;
                    if (textOld === newLabel || newLabel === "") {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: textOld,
                                                  contNew: newLabel,
                                                  onDiscard: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeLabelEditMode(__x, stmtId, textOld);
                                                          });
                                                    }),
                                                  onSave: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      actCompleteEditLabel(stmtId, newLabel);
                                                    }),
                                                  onContinueEditing: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                onTypEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setTypEditMode, stmt.id);
                  }),
                onTypEditDone: (function (newTyp, newIsGoal) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeTypEditMode(__x, stmt.id, newTyp, newIsGoal);
                        });
                  }),
                onContEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setContEditMode, stmt.id);
                  }),
                onContEditDone: (function (newContText) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeContEditMode(__x, stmt.id, newContText);
                        });
                  }),
                onContEditCancel: (function (newContText) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var contOld = stmt$1.cont;
                    var contNew = MM_wrk_editor.strToCont(newContText, undefined, undefined);
                    var textOld = MM_wrk_editor.contToStr(contOld);
                    var textNew = MM_wrk_editor.contToStr(contNew);
                    if (textOld === textNew || textOld === "" && textNew === state.preCtxData.settingsV.val.defaultStmtType.trim()) {
                      if (textOld === "") {
                        return setState(function (__x) {
                                    return MM_wrk_editor.deleteStmt(__x, stmtId);
                                  });
                      } else {
                        return setState(function (__x) {
                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                  });
                      }
                    } else if (textNew === "") {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: MM_cmp_user_stmt.rndContText(contOld, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                  removeStmt: textOld === "",
                                                  contNew: MM_cmp_user_stmt.rndContText(contNew, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                                  onDiscard: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      if (textOld === "") {
                                                        return setState(function (__x) {
                                                                    return MM_wrk_editor.deleteStmt(__x, stmtId);
                                                                  });
                                                      } else {
                                                        return setState(function (__x) {
                                                                    return MM_wrk_editor.completeContEditMode(__x, stmtId, textOld);
                                                                  });
                                                      }
                                                    }),
                                                  onSave: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeContEditMode(__x, stmtId, textNew);
                                                          });
                                                    }),
                                                  onContinueEditing: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                onSyntaxTreeUpdatedWithoutContentChange: (function (newStmtCont) {
                    setStatePriv(function (__x) {
                          return MM_wrk_editor.setStmtCont(__x, stmt.id, newStmtCont);
                        });
                  }),
                onJstfEditRequested: (function () {
                    actBeginEdit(MM_wrk_editor.setJstfEditMode, stmt.id);
                  }),
                onJstfEditDone: (function (newJstf) {
                    setState(function (__x) {
                          return MM_wrk_editor.completeJstfEditMode(__x, stmt.id, newJstf);
                        });
                  }),
                onJstfEditCancel: (function (newJstf) {
                    var stmtId = stmt.id;
                    var stmt$1 = MM_wrk_editor.editorGetStmtById(state, stmtId);
                    if (stmt$1 === undefined) {
                      return ;
                    }
                    var match = stmt$1.typ;
                    var textOld;
                    textOld = match === "E" ? MM_wrk_editor.defaultJstfForHyp : stmt$1.jstfText.trim();
                    var newJstfTextTrim = newJstf.trim();
                    var match$1 = stmt$1.typ;
                    var textNew;
                    textNew = match$1 === "E" && MM_wrk_editor.defaultJstfForHyp === newJstfTextTrim.toUpperCase() ? MM_wrk_editor.defaultJstfForHyp : newJstfTextTrim;
                    var nothingChanged = textOld === textNew;
                    if (nothingChanged) {
                      return setState(function (__x) {
                                  return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                });
                    } else {
                      Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                  return null;
                                })), (function (modalId) {
                              Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                      return React.createElement(MM_cmp_save_or_discard.make, {
                                                  contOld: textOld,
                                                  contNew: textNew,
                                                  onDiscard: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textOld);
                                                          });
                                                    }),
                                                  onSave: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                      setState(function (__x) {
                                                            return MM_wrk_editor.completeJstfEditMode(__x, stmtId, textNew);
                                                          });
                                                    }),
                                                  onContinueEditing: (function () {
                                                      Expln_React_Modal.closeModal(modalRef, modalId);
                                                    })
                                                });
                                    }));
                            }));
                      return ;
                    }
                  }),
                checkboxDisabled: editIsActive,
                checkboxChecked: MM_wrk_editor.isStmtChecked(state, stmt.id),
                checkboxOnChange: (function (param, shift) {
                    var id = stmt.id;
                    if (shift) {
                      return setStatePriv(function (st) {
                                  return MM_wrk_editor.toggleStmtCheckedWithShift(st, id, showBkmOnlyRef.current);
                                });
                    } else {
                      return setStatePriv(function (st) {
                                  return MM_wrk_editor.toggleStmtChecked(st, id);
                                });
                    }
                  }),
                onGenerateProof: (function () {
                    actExportProof(stmt.id);
                  }),
                onDebug: (function () {
                    var stmtId = stmt.id;
                    var st = MM_wrk_editor.uncheckAllStmts(state);
                    var st$1 = MM_wrk_editor.toggleStmtChecked(st, stmtId);
                    var stmt$1 = MM_wrk_editor.getTheOnlyCheckedStmt(st$1);
                    var singleProvableChecked = stmt$1 !== undefined && stmt$1.typ === "P" ? stmt$1 : undefined;
                    if (singleProvableChecked === undefined) {
                      return ;
                    }
                    var rootUserStmts = MM_wrk_editor.getRootStmtsForUnification(st$1);
                    var rootStmts = rootUserStmts.map(MM_wrk_editor.userStmtToRootStmt);
                    var match = getArgs0AndAsrtLabel([singleProvableChecked], rootStmts);
                    var match$1 = match !== undefined ? [
                        MM_bottom_up_prover_params.bottomUpProverParamsMakeDefault(match[1], 1, "Less", false, false, false, match[0], [], undefined),
                        2
                      ] : [
                        MM_bottom_up_prover_params.bottomUpProverParamsMakeDefault(undefined, 1, "No", false, false, false, rootStmts.map(function (stmt) {
                                  return stmt.expr;
                                }), [], undefined),
                        1
                      ];
                    actUnify(stmtId, match$1[0], match$1[1], undefined, undefined, undefined, undefined, undefined);
                  }),
                onOpenSubstitutionDialog: onOpenSubstitutionDialogRef,
                addStmtAbove: (function (text) {
                    var id = stmt.id;
                    var isBkm = stmt.isBkm || showBkmOnly && (stmt.typ === "E" || stmt.isGoal);
                    setState(function (st) {
                          var st$1 = addStmtAbove(st, id, text, isBkm);
                          return MM_wrk_editor.uncheckAllStmts(st$1);
                        });
                  }),
                addStmtBelow: (function (text) {
                    var id = stmt.id;
                    var isBkm = stmt.isBkm || showBkmOnly && (stmt.typ === "E" || stmt.isGoal);
                    setState(function (st) {
                          var st$1 = addStmtAbove(st, id, text, isBkm);
                          var st$2 = MM_wrk_editor.moveCheckedStmts(st$1, true);
                          return MM_wrk_editor.uncheckAllStmts(st$2);
                        });
                  }),
                setShowTabs: setShowTabs,
                openFrameExplorer: openFrameExplorer
              });
  };
  var rndStmtAndErrors = function (stmt) {
    return JsxPPXReactSupportU.createElementVariadicWithKey(stmt.id, Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, [
                rndStmt(stmt),
                rndErrors(stmt)
              ]);
  };
  var rndDescr = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "12px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                      })
                  }, "Description"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(React.createElement(MM_cmp_multiline_text.make, {
                              text: state.descr,
                              editMode: state.descrEditMode,
                              onEditRequested: (function () {
                                  actBeginEdit0(MM_wrk_editor.setDescrEditMode);
                                }),
                              onEditDone: actDescrEditComplete,
                              onEditCancel: (function (newText) {
                                  var textOldUntrimed = state.descr;
                                  var textOld = textOldUntrimed.trim();
                                  var textNew = newText.trim();
                                  if (textOld === textNew || textNew === "") {
                                    return setState(function (__x) {
                                                return MM_wrk_editor.completeDescrEditMode(__x, textOldUntrimed);
                                              });
                                  } else {
                                    Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                                return null;
                                              })), (function (modalId) {
                                            Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                    return React.createElement(MM_cmp_save_or_discard.make, {
                                                                contOld: React.createElement("pre", undefined, textOld),
                                                                contNew: React.createElement("pre", undefined, textNew),
                                                                onDiscard: (function () {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    setState(function (__x) {
                                                                          return MM_wrk_editor.completeDescrEditMode(__x, textOldUntrimed);
                                                                        });
                                                                  }),
                                                                onSave: (function () {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                    setState(function (__x) {
                                                                          return MM_wrk_editor.completeDescrEditMode(__x, textNew);
                                                                        });
                                                                  }),
                                                                onContinueEditing: (function () {
                                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                                  })
                                                              });
                                                  }));
                                          }));
                                    return ;
                                  }
                                }),
                              editByClick: false,
                              editByAltClick: true,
                              longClickEnabled: state.preCtxData.settingsV.val.longClickEnabled,
                              longClickDelayMs: state.preCtxData.settingsV.val.longClickDelayMs,
                              renderer: (function (str) {
                                  return React.createElement(Static_XML_to_HTML.make, {
                                              xmlStr: str
                                            });
                                }),
                              fullWidth: true,
                              onHelp: (function () {
                                  Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                              return null;
                                            })), (function (modalId) {
                                          Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                                  return React.createElement(XML_formatting_help.make, {
                                                              onClose: (function () {
                                                                  Expln_React_Modal.closeModal(modalRef, modalId);
                                                                })
                                                            });
                                                }));
                                        }));
                                }),
                              onDelete: (function () {
                                  actDescrEditComplete("");
                                })
                            }))
                  }));
  };
  var rndVars = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginTop: "3px",
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                      })
                  }, "Variables"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.varsText,
                        editMode: state.varsEditMode,
                        onEditRequested: (function () {
                            actBeginEdit0(MM_wrk_editor.setVarsEditMode);
                          }),
                        onEditDone: actVarsEditComplete,
                        onEditCancel: (function (newText) {
                            var textOld = state.varsText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeVarsEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        editByClick: true,
                        editByAltClick: true,
                        longClickEnabled: state.preCtxData.settingsV.val.longClickEnabled,
                        longClickDelayMs: state.preCtxData.settingsV.val.longClickDelayMs,
                        onDelete: (function () {
                            actVarsEditComplete("");
                          })
                      }), rndError(state.varsErr, "red")));
  };
  var rndDisj = function () {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "flex-start",
                spacing: 1,
                style: {
                  marginLeft: "7px"
                },
                children: Caml_option.some(null)
              }, React.createElement("span", {
                    style: {
                      cursor: "pointer"
                    },
                    onClick: (function (param) {
                        actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                      })
                  }, "Disjoints"), React.createElement(Expln_React_Column.make, {
                    children: Caml_option.some(null)
                  }, React.createElement(MM_cmp_multiline_text.make, {
                        text: state.disjText,
                        editMode: state.disjEditMode,
                        onEditRequested: (function () {
                            actBeginEdit0(MM_wrk_editor.setDisjEditMode);
                          }),
                        onEditDone: actDisjEditComplete,
                        onEditCancel: (function (newText) {
                            var textOld = state.disjText.trim();
                            var textNew = newText.trim();
                            if (textOld === textNew || textNew === "") {
                              return setState(function (__x) {
                                          return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                        });
                            } else {
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function () {
                                          return null;
                                        })), (function (modalId) {
                                      Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                              return React.createElement(MM_cmp_save_or_discard.make, {
                                                          contOld: React.createElement("pre", undefined, textOld),
                                                          contNew: React.createElement("pre", undefined, textNew),
                                                          onDiscard: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textOld);
                                                                  });
                                                            }),
                                                          onSave: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                              setState(function (__x) {
                                                                    return MM_wrk_editor.completeDisjEditMode(__x, textNew);
                                                                  });
                                                            }),
                                                          onContinueEditing: (function () {
                                                              Expln_React_Modal.closeModal(modalRef, modalId);
                                                            })
                                                        });
                                            }));
                                    }));
                              return ;
                            }
                          }),
                        editByClick: true,
                        editByAltClick: true,
                        longClickEnabled: state.preCtxData.settingsV.val.longClickEnabled,
                        longClickDelayMs: state.preCtxData.settingsV.val.longClickDelayMs,
                        onDelete: (function () {
                            actDisjEditComplete("");
                          })
                      }), rndError(state.disjErr, "red")));
  };
  var getPagesWithErrors = function () {
    var pageHasErrors = function (pageIdx) {
      var minIdx = Math.imul(pageIdx, stepsPerPage);
      var maxIdx = (minIdx + stepsPerPage | 0) - 1 | 0;
      return stmtsToShow.findIndex(function (stmt, i) {
                  if (minIdx <= i && i <= maxIdx) {
                    return MM_wrk_editor.userStmtHasAnyErrors(stmt);
                  } else {
                    return false;
                  }
                }) >= 0;
    };
    return Belt_Array.range(0, maxPageIdx).filter(pageHasErrors);
  };
  var actGoToNextPageWithErrors = function () {
    var pagesWithErrors = getPagesWithErrors();
    if (pagesWithErrors.length <= 0) {
      return ;
    }
    var i = getPagesWithErrors().find(function (i) {
          return pageIdx < i;
        });
    if (i !== undefined) {
      return setPageIdx(function (param) {
                  return i;
                });
    }
    var pageIdx$1 = pagesWithErrors[0];
    setPageIdx(function (param) {
          return pageIdx$1;
        });
  };
  var actGoToPrevPageWithErrors = function () {
    var pagesWithErrors = getPagesWithErrors();
    if (pagesWithErrors.length <= 0) {
      return ;
    }
    var i = getPagesWithErrors().find(function (i) {
          return i < pageIdx;
        });
    if (i !== undefined) {
      return setPageIdx(function (param) {
                  return i;
                });
    }
    var pageIdx$1 = pagesWithErrors[pagesWithErrors.length - 1 | 0];
    setPageIdx(function (param) {
          return pageIdx$1;
        });
  };
  var paginationIsRequired = stmtsToShow.length > stepsPerPage;
  var rndPagination = function () {
    if (paginationIsRequired) {
      return React.createElement("div", {
                  style: {
                    padding: "5px"
                  }
                }, React.createElement(PaginationCmp.make, {
                      numOfPages: numOfPages,
                      pageIdx: pageIdx,
                      siblingCount: 1000,
                      itemsPerPage: stepsPerPage,
                      showGoToPage: false,
                      showItemsPerPage: false,
                      onPageIdxChange: actGoToPage
                    }));
    } else {
      return null;
    }
  };
  var rndGoToNextPageWithErrorsBtn = function () {
    if (thereAreAnyErrorsInEditor && paginationIsRequired) {
      return React.createElement(Expln_React_Row.make, {
                  style: {
                    padding: "5px"
                  },
                  children: Caml_option.some(null)
                }, MM_react_common.rndSmallTextBtn(actGoToPrevPageWithErrors, "< Go to previos page with errors", "red"), MM_react_common.rndSmallTextBtn(actGoToNextPageWithErrors, "Go to next page with errors >", "red"));
    } else {
      return null;
    }
  };
  var rndStmts = function () {
    return React.createElement(Expln_React_Column.make, {
                spacing: 0,
                children: Caml_option.some(null)
              }, rndPagination(), rndGoToNextPageWithErrorsBtn(), stmtsToShow.filter(function (param, i) {
                      if (stmtBeginIdx <= i) {
                        return i <= stmtEndIdx;
                      } else {
                        return false;
                      }
                    }).map(rndStmtAndErrors), rndGoToNextPageWithErrorsBtn(), rndPagination());
  };
  var rndFooter = function () {
    return Belt_Array.range(1, 12).map(function (i) {
                return React.createElement("span", {
                            key: String(i),
                            style: {
                              fontSize: "20px"
                            }
                          }, Common.nbsp);
              });
  };
  var rndShowContentBtn = function () {
    return React.createElement(Expln_React_Column.make, {
                spacing: 1.0,
                style: {
                  padding: "20px"
                },
                children: Caml_option.some(null)
              }, "Editor content is hidden.", React.createElement(Button, {
                    onClick: (function (param) {
                        setContIsHidden(function (param) {
                              return false;
                            });
                      }),
                    variant: "contained",
                    children: "Show editor content"
                  }));
  };
  var actSetStateFromApi = function (update) {
    return Expln_utils_promise.promise(function (resolve) {
                setState(function (st) {
                      var msg = update(st);
                      if (msg.TAG === "Ok") {
                        var match = msg._0;
                        var json = match[1];
                        return MM_wrk_editor.setNextAction(match[0], {
                                    TAG: "Action",
                                    _0: (function () {
                                        resolve({
                                              TAG: "Ok",
                                              _0: json
                                            });
                                      })
                                  });
                      }
                      var msg$1 = msg._0;
                      return MM_wrk_editor.setNextAction(st, {
                                  TAG: "Action",
                                  _0: (function () {
                                      resolve({
                                            TAG: "Error",
                                            _0: msg$1
                                          });
                                    })
                                });
                    });
              });
  };
  var actBuildSyntaxTrees = function (exprs) {
    var wrkCtx = state.wrkCtx;
    if (wrkCtx === undefined) {
      return {
              TAG: "Error",
              _0: "There are errors in the editor."
            };
    }
    var wrkCtx$1 = Caml_option.valFromOption(wrkCtx);
    var syms = exprs.map(Common.getSpaceSeparatedValuesAsArray);
    var unrecognizedSymbol = Belt_HashSetString.toArray(Belt_HashSetString.fromArray(Expln_utils_common.arrFlatMap(syms, (function (a) {
                      return a;
                    })))).find(function (sym) {
          return Belt_Option.isNone(MM_context.ctxSymToInt(wrkCtx$1, sym));
        });
    if (unrecognizedSymbol !== undefined) {
      return {
              TAG: "Error",
              _0: "Unrecognized symbol '" + unrecognizedSymbol + "'"
            };
    } else {
      return MM_wrk_editor.textToSyntaxTree(wrkCtx$1, syms, state.preCtxData.syntaxTypes, state.preCtxData.frms, state.preCtxData.settingsV.val.allowedFrms.inSyntax, state.preCtxData.parenCnt, undefined, (function (param) {
                    
                  }));
    }
  };
  var actSetEditorContIsHidden = function (contIsHidden) {
    setContIsHidden(function (param) {
          return contIsHidden;
        });
    return Expln_utils_promise.promiseResolved();
  };
  var getAsrtSyntaxTrees = function () {
    var asrtSyntaxTrees = preCtxData.asrtSyntaxTrees;
    if (asrtSyntaxTrees !== undefined) {
      return Promise.resolve(Caml_option.valFromOption(asrtSyntaxTrees));
    } else {
      return Expln_React_Modal.openModal(modalRef, (function () {
                      return MM_react_common.rndProgress("Building syntax trees for all assertions", 0, undefined);
                    })).then(function (modalId) {
                  Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                          return MM_react_common.rndProgress("Building syntax trees for all assertions", 0, makeActTerminate(modalId));
                        }));
                  return MM_wrk_syntax_tree.buildSyntaxTreesForAllAssertions(preCtxData.settingsV, preCtxData.ctxV.ver, preCtxData.ctxV.val.min, (function (pct) {
                                  Expln_React_Modal.updateModal(modalRef, modalId, (function () {
                                          return MM_react_common.rndProgress("Building syntax trees for all assertions", pct, makeActTerminate(modalId));
                                        }));
                                })).then(function (asrtSyntaxTreesArr) {
                              preCtxData.asrtSyntaxTrees = Caml_option.some(Belt_HashMapString.fromArray(asrtSyntaxTreesArr));
                              Expln_React_Modal.closeModal(modalRef, modalId);
                              return Core__Option.getExn(preCtxData.asrtSyntaxTrees, "MM_cmp_editor.getAsrtSyntaxTrees.1");
                            });
                });
    }
  };
  MM_api_editor.updateEditorData(editorId, preCtxData.settingsV.val.unifMetavarPrefix, state, actSetStateFromApi, actSetEditorContIsHidden, generalModificationActionIsEnabled, (function (params) {
          return Expln_utils_promise.promise(function (resolve) {
                      actUnify(params.stmtId, params.bottomUpProverParams, params.debugLevel, true, params.delayBeforeStartMs, params.selectFirstFoundProof, (function (stmtsDto) {
                              if (stmtsDto !== undefined) {
                                if (stmtsDto.TAG === "Ok") {
                                  return resolve({
                                              TAG: "Ok",
                                              _0: true
                                            });
                                } else {
                                  return resolve({
                                              TAG: "Error",
                                              _0: stmtsDto._0
                                            });
                                }
                              } else {
                                return resolve({
                                            TAG: "Ok",
                                            _0: false
                                          });
                              }
                            }), undefined);
                    });
        }), generalModificationActionIsEnabled, (function () {
          return Expln_utils_promise.promise(function (resolve) {
                      setState(function (st) {
                            var st$1 = MM_wrk_editor.uncheckAllStmts(st);
                            return MM_wrk_editor.setNextAction(st$1, {
                                        TAG: "UnifyAll",
                                        nextAction: (function () {
                                            resolve();
                                          })
                                      });
                          });
                    });
        }), actBuildSyntaxTrees, getAsrtSyntaxTrees, actAddAsrtByLabel);
  return React.createElement(Expln_React_ContentWithStickyHeader.make, {
              top: props.top,
              header: rndButtons(),
              content: (function (param) {
                  return React.createElement(Expln_React_Column.make, {
                              spacing: 0,
                              children: Caml_option.some(null)
                            }, rndMainMenu(), contIsHidden ? rndShowContentBtn() : React.createElement(Expln_React_Column.make, {
                                    spacing: 0,
                                    children: Caml_option.some(null)
                                  }, rndDescr(), rndVars(), rndDisj(), rndStmts(), rndFooter()));
                })
            });
}

var editorHistRegLocStorKey = "hist-reg";

var editorHistTmpLocStorKey = "hist-tmp";

var make = MM_cmp_editor;

exports.editorStateLocStorKey = editorStateLocStorKey;
exports.editorHistLocStorKey = editorHistLocStorKey;
exports.editorHistRegLocStorKey = editorHistRegLocStorKey;
exports.editorHistTmpLocStorKey = editorHistTmpLocStorKey;
exports.lastUsedAsrtSearchTypLocStorKey = lastUsedAsrtSearchTypLocStorKey;
exports.getEditorLocStorKey = getEditorLocStorKey;
exports.getEditorHistLocStorKey = getEditorHistLocStorKey;
exports.editorSaveStateToLocStor = editorSaveStateToLocStor;
exports.histSaveToLocStor = histSaveToLocStor;
exports.histReadFromLocStor = histReadFromLocStor;
exports.rndIconButton = rndIconButton;
exports.saveLastUsedTyp = saveLastUsedTyp;
exports.getLastUsedTyp = getLastUsedTyp;
exports.jsonStrOptToEditorStateLocStor = jsonStrOptToEditorStateLocStor;
exports.loadEditorInitialStateFromLocStor = loadEditorInitialStateFromLocStor;
exports.previousEditingIsNotCompletedTitle = previousEditingIsNotCompletedTitle;
exports.previousEditingIsNotCompletedText = previousEditingIsNotCompletedText;
exports.infoAboutGettingCompletedProof = infoAboutGettingCompletedProof;
exports.infoAboutInliningTheorems = infoAboutInliningTheorems;
exports.make = make;
/* react Not a pure module */
